let $ = jQuery.noConflict(),
	devMode,
	mobileCheck = false,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	clickOrTouch,
	mobileResizeCallbacks = [];

$(function () {
	new StarterKitMcube();
	// Composants Mobile & Desktop
	new BannerSlider();
	new Buttons();
	new RichText();
	new GoogleMap();
	new IframeVideos();
	new NavMain();

	new BlockSliderImages();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}
});
